/**
 * Contact Status Constants
 *
 * Complete `contact_status` value set (mirrored by codegen `Contact_Status`).
 * Use `z.enum(CONTACT_STATUS_VALUES)` for tool/form input — never a hand-typed
 * subset (the chat tools previously exposed only prospect/customer/lead/inactive,
 * silently hiding churned/other_non_revenue/personal/system_notification).
 * `satisfies readonly Contact_Status[]` breaks `tsc` if the DB enum drifts.
 */

import type { Contact_Status } from "@/src/gql/graphql";

export const CONTACT_STATUS_VALUES = [
  "lead",
  "prospect",
  "customer",
  "churned",
  "inactive",
  "other_non_revenue",
  "personal",
  "system_notification",
] as const satisfies readonly Contact_Status[];

/**
 * Human-selectable statuses shown in contact FORMS — a deliberate subset that
 * hides the internal / non-revenue statuses (personal, system_notification,
 * other_non_revenue). `satisfies readonly Contact_Status[]` guarantees every
 * entry is a real contact_status (a subset, never an invalid value); add/remove
 * freely, but tsc breaks if one stops being a valid enum member.
 */
export const CONTACT_STATUS_FORM_VALUES = [
  "lead",
  "prospect",
  "customer",
  "churned",
  "inactive",
] as const satisfies readonly Contact_Status[];

/**
 * Statuses accepted from inbound contact INGESTION (webhook). Deliberate subset
 * — inbound sources only ever set these. Guaranteed-valid subset of contact_status.
 */
export const CONTACT_STATUS_INGESTION_VALUES = [
  "lead",
  "prospect",
  "customer",
  "inactive",
] as const satisfies readonly Contact_Status[];
